export default __webpack_public_path__ + "static/media/Zebra-ZT410.1e5d4522.png";